import React, { useState } from "react";
import { ArrowUpRight, Clock, FileText } from "lucide-react";
import Navbar from "../Navbar";
import { CTASection, Footer } from "../CTAFooter";
import { blogCategories, blogPosts } from "../../data/mock";

const Blogs = () => {
  const [active, setActive] = useState("All");

  const filtered = active === "All" ? blogPosts : blogPosts.filter((p) => p.category === active);

  return (
    <div className="min-h-screen bg-white font-sans text-neutral-900">
      <Navbar />

      {/* Header */}
      <section className="pt-16 pb-10">
        <div className="max-w-[900px] mx-auto px-6 text-center">
          <span className="inline-flex items-center gap-2 text-[11px] tracking-[0.18em] uppercase text-neutral-500 border border-black/10 rounded-full px-3 py-1.5 bg-white/60">
            <span className="w-1.5 h-1.5 rounded-full bg-black"></span> Knowledge center
          </span>
          <h1 className="mt-6 text-[32px] sm:text-[48px] leading-[1.08] tracking-[-0.02em] font-semibold text-neutral-950">
            Latest insights &amp; case studies
          </h1>
          <p className="mt-6 text-[17px] text-neutral-600 max-w-2xl mx-auto">
            Practical breakdowns on performance marketing, SEO, and growth: no fluff, just what actually moves the needle.
          </p>
        </div>
      </section>

      {/* Category filter */}
      <section className="pb-10">
        <div className="max-w-[1280px] mx-auto px-6">
          <div className="flex flex-wrap items-center justify-center gap-2">
            {blogCategories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActive(cat)}
                className={`text-sm px-4 py-2 rounded-full border transition-colors ${
                  active === cat
                    ? "bg-black text-white border-black"
                    : "bg-white text-neutral-700 border-black/10 hover:bg-neutral-50"
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Posts grid */}
      <section className="pb-24 bg-neutral-50 pt-4">
        <div className="max-w-[1280px] mx-auto px-6">
          {filtered.length === 0 ? (
            <p className="text-center text-neutral-500 py-16">No posts in this category yet.</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {filtered.map((post) => (
                <div
                  key={post.slug}
                  className="bg-white rounded-3xl overflow-hidden border border-black/5 hover:shadow-lg transition-all duration-300 flex flex-col"
                >
                  <div className="bg-neutral-100 aspect-[16/10] flex items-center justify-center overflow-hidden">
                    {post.image ? (
                      <img
                        src={post.image.src}
                        alt={post.image.alt}
                        loading="lazy"
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <FileText className="w-8 h-8 text-neutral-300" />
                    )}
                  </div>
                  <div className="p-7 flex flex-col flex-1">
                    <span className="text-[11px] font-semibold uppercase tracking-wide text-neutral-500">
                      {post.category}
                    </span>
                    <h3 className="mt-3 text-lg font-semibold text-neutral-950 leading-snug">
                      {post.title}
                    </h3>
                    <p className="mt-2 text-sm text-neutral-600 leading-relaxed flex-1">{post.excerpt}</p>

                    {post.body ? (
                      <a
                        href={`/blog/${post.slug}`}
                        className="mt-5 inline-flex items-center gap-1.5 text-sm text-neutral-900 font-medium hover:gap-2.5 transition-all"
                      >
                        Read more <ArrowUpRight className="w-4 h-4" />
                      </a>
                    ) : (
                      <span className="mt-5 inline-flex items-center gap-1.5 text-sm text-neutral-400">
                        <Clock className="w-3.5 h-3.5" /> Full article coming soon
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      <CTASection />
      <Footer />
    </div>
  );
};

export default Blogs;
